import Component from '../abstracts/Component';
import vex from 'vex-js';
import Cookies from 'js-cookie';
import TrackingComponent from "./TrackingComponent";
import FooterNewsletterComponent from "./FooterNewsletterComponent";

export default class ExitPopupComponent extends Component {
  get COOKIE_NAME() {
    return {
      popUpHide: 'exit_popup_hide',
    };
  }

  get SELECTORS() {
    return {
      exitPopup: '[data-exit-popup]',
      exitFormEmail: '[data-email-input-newsletter]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.exitPopup = this.$component.querySelector(this.SELECTORS.exitPopup);
    this.hasShownPopup = false;
    this.trackingComponent = new TrackingComponent();
  }

  triggerExitPopup(e) {
    if (!this.hasShownPopup && !Cookies.get(this.COOKIE_NAME.popUpHide)) {
      this.hasShownPopup = true;
      Cookies.set(this.COOKIE_NAME.popUpHide, '1', { sameSite: 'strict' });
      this.openExitPopUp();
      this.trackingComponent.trackAction('exitIntentStart', e.type);
    }
  }

  openExitPopUp() {
    const ctx = this;
    this.exitPopup.classList.remove('hidden');
    vex.open({
      unsafeContent: this.exitPopup,
      showCloseButton: true,
      className: '--exit-popup popup',
      closeClassName: 'popup__close icon-close',
      afterOpen: function() {
        this.closeEl.classList.remove('vex-close');
        const exitPopupWrapper = ctx.exitPopup.querySelector('[data-popup-wrapper]');
        if (exitPopupWrapper) {
          const ExitPopupNewsletterComponent = new FooterNewsletterComponent(exitPopupWrapper);
          ExitPopupNewsletterComponent.render();
        }
        ctx.exitPopup.querySelector(ctx.SELECTORS.exitFormEmail).focus();
      },
    });
  }

  render() {
    const handler = (e) => {
      e.preventDefault();
      this.triggerExitPopup(e);
    };

    document.addEventListener('mouseleave', (e) => {
      //const outTop = e.clientY <= 0;
      const outLeft = e.clientX <= 0;
      const outRight = e.clientX >= window.innerWidth;
      const outBottom = e.clientY >= window.innerHeight;
      if (outLeft || outRight || outBottom) handler(e);
    });

    //window.addEventListener('beforeunload', handler);
    window.addEventListener('popstate', handler);
  }
}
